export default "__VITE_ASSET__303217d3__"